"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    marginBottom: props => {
      return theme.spacing(props.spacing);
    },
    "& > header": {
      position: "sticky",
      zIndex: 2,
      top: 0
    }
  },
  header: {
    display: "flex",
    width: "100%",
    alignItems: "baseline"
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold"
  }
}));

const FinderSection = ({
  expanded = true,
  spacing = 2,
  label,
  title,
  description,
  action = [],
  children
}) => {
  const classes = useStyles({
    spacing
  });

  if (!title && label) {
    title = label;
  }

  const renderHeader = () => {
    if (title) {
      return _react.default.createElement("header", {
        className: classes.header
      }, _react.default.createElement("div", {
        className: classes.leading
      }, _react.default.createElement(_Typography.default, {
        className: classes.title,
        nowrap: true
      }, title), description && _react.default.createElement(_Typography.default, {
        className: classes.description
      }, description)));
    }
  };

  return _react.default.createElement("section", {
    className: classes.root,
    "aria-expanded": expanded
  }, renderHeader(), expanded && children);
};

var _default = FinderSection;
exports.default = _default;
module.exports = exports.default;